var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVideoCallIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 19,
    viewBox: "0 0 27 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 2.42969C2.57812 2.42969 2.25 2.80469 2.25 3.17969V15.1797C2.25 15.6016 2.57812 15.9297 3 15.9297H15C15.375 15.9297 15.75 15.6016 15.75 15.1797V3.17969C15.75 2.80469 15.375 2.42969 15 2.42969H3ZM0 3.17969C0 1.53906 1.3125 0.179688 3 0.179688H15C16.6406 0.179688 18 1.53906 18 3.17969V4.72656V13.6328V15.1797C18 16.8672 16.6406 18.1797 15 18.1797H3C1.3125 18.1797 0 16.8672 0 15.1797V3.17969ZM24.75 14.2422V4.16406L19.5 6.50781V4.07031L24.375 1.86719C24.6094 1.77344 24.8438 1.67969 25.125 1.67969C26.1562 1.67969 27 2.52344 27 3.55469V14.8516C27 15.8828 26.1562 16.6797 25.125 16.6797C24.8438 16.6797 24.6094 16.6328 24.375 16.5391L19.5 14.3359V11.8516L24.75 14.2422Z",
    fill: "#006D5B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoCallIcon);
export default __webpack_public_path__ + "static/media/videoCallIcon.36336d6b6a1c9dea94585f479541a412.svg";
export { ForwardRef as ReactComponent };